/**
 * Global theme behaviour.
 *
 * Scroll reveal: elements with .reveal start hidden (see critical.css) and get
 * .in when they scroll into view. Ported from the design concept, with two
 * changes: it re-scans after section renders so the theme editor behaves, and
 * it bails out entirely under prefers-reduced-motion.
 */
(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(root) {
    root.querySelectorAll('.reveal').forEach((el) => el.classList.add('in'));
  }

  if (REDUCED || !('IntersectionObserver' in window)) {
    revealAll(document);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
  );

  function observe(root) {
    root.querySelectorAll('.reveal:not(.in)').forEach((el) => observer.observe(el));
  }

  observe(document);

  // Theme editor: sections are re-rendered without a page load.
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
